import { loadProgress, saveProgress } from '../shared/progress';
import { SKILL_CATALOG, getSkill } from '../shared/skills';
import { FACTIONS } from '../shared/factions';
import type { FactionId } from '../shared/types';

const MAX_SLOTS = 4;

export function renderLoadout(container: HTMLElement, onConfirm: () => void, onCancel: () => void): void {
  const root = document.createElement('div');
  root.className = 'loadout-screen';
  container.appendChild(root);

  const progress = loadProgress();
  if (!progress) { root.remove(); onCancel(); return; }

  // Working copy — only persisted on Confirm
  const loadout: string[] = [...progress.currentLoadout];

  function render(): void {
    const unlockedNonBuiltin = SKILL_CATALOG.filter(
      s => s.faction !== 'builtin' && progress!.unlockedSkills.includes(s.id),
    );

    root.innerHTML = `
      <h1>配置 Loadout</h1>
      <p>選擇最多 ${MAX_SLOTS} 個技能(同技能不可重複,同門派可)</p>
      <div class="loadout-slots"></div>
      <h3>已解鎖技能</h3>
      <div class="skill-pool"></div>
      <button class="secondary-btn" id="open-weapon-select" data-testid="loadout-weapon-select"
        style="margin-top:16px;">🔫 選擇主武器 / 升級</button>
      <div style="display: flex; gap: 12px; margin-top: 24px;">
        <button class="secondary-btn" id="cancel-loadout">取消</button>
        <button class="primary-btn" id="confirm-loadout">確定出戰</button>
      </div>
    `;

    const slotsEl = root.querySelector('.loadout-slots')!;
    for (let i = 0; i < MAX_SLOTS; i++) {
      const id = loadout[i];
      const skill = id ? getSkill(id) : null;
      const faction = skill?.faction !== 'builtin' && skill?.faction
        ? FACTIONS[skill.faction as FactionId]
        : null;
      const slot = document.createElement('div');
      slot.className = 'loadout-slot' + (skill ? ' filled' : ' empty');
      slot.innerHTML = skill
        ? `<div class="slot-key">${i + 1}</div><div class="slot-emoji">${faction?.emoji ?? '✨'}</div><div class="slot-name">${skill.displayName}</div><button class="slot-remove">×</button>`
        : `<div class="slot-key">${i + 1}</div><div class="slot-empty-label">空</div>`;
      if (skill) {
        slot.querySelector('.slot-remove')!.addEventListener('click', () => {
          loadout.splice(i, 1);
          render();
        });
      }
      slotsEl.appendChild(slot);
    }

    const poolEl = root.querySelector('.skill-pool')!;
    if (unlockedNonBuiltin.length === 0) {
      poolEl.innerHTML = '<p style="color:#88a;">尚未解鎖任何門派技能。去修煉學院上課解鎖!</p>';
    }
    for (const skill of unlockedNonBuiltin) {
      const inLoadout = loadout.includes(skill.id);
      const faction = FACTIONS[skill.faction as FactionId];
      const card = document.createElement('div');
      card.className = 'pool-card' + (inLoadout ? ' selected' : '');
      card.innerHTML = `
        <div class="pool-emoji">${faction.emoji}</div>
        <div class="pool-name">${skill.displayName}</div>
        <div class="pool-desc">${skill.description}</div>
      `;
      card.addEventListener('click', () => {
        if (inLoadout) return; // can't pick same skill twice
        if (loadout.length >= MAX_SLOTS) return;
        loadout.push(skill.id);
        render();
      });
      poolEl.appendChild(card);
    }

    // R-005 P2: 出戰前選主武器 / 升級。dispatch event → main.ts setMode('weapon-select')。
    // 不存目前 loadout(技能槽),回來重進 loadout 重選即可(避免半套狀態)。
    root.querySelector('#open-weapon-select')!.addEventListener('click', () => {
      root.remove();
      window.dispatchEvent(new CustomEvent('ef:open-weapon-select'));
    });
    root.querySelector('#cancel-loadout')!.addEventListener('click', () => { root.remove(); onCancel(); });
    root.querySelector('#confirm-loadout')!.addEventListener('click', () => {
      progress!.currentLoadout = loadout;
      saveProgress(progress!);
      root.remove();
      onConfirm();
    });
  }

  render();
}
